import { all, takeEvery, put, select, call, fork } from 'redux-saga/effects'
import actionTypes, { ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY } from '../actionTypes'
import actions from '../actions'
import selectors from '../selectors'
import { showError } from '../../toastr/utils'
import makeAPIRequest from '../../api/sagas'
import { ORG_INACTIVE_NOTIFICATIONS_ENDPOINT } from 'app/constants/api/orgInactiveNotifications'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'

export default function* repeatDaySaga() {
  yield all([fork(watchChangeRepeatDay), fork(watchPostRepeatDay)])
}

export function* watchChangeRepeatDay() {
  yield takeEvery(ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY, handleChangeRepeatDay)
}

export function* handleChangeRepeatDay({ payload }) {
  const { day } = payload
  yield put(actions.orgInactiveNotifications.postRepeatDay.request(day))
}

export function* watchPostRepeatDay() {
  yield takeEvery(actionTypes.ORG_INACTIVE_NOTIFICATIONS.POST_REPEAT_DAY.REQUEST, handlePostRepeatDayRequest)
}

export function* handlePostRepeatDayRequest({ payload: { data: day } }) {
  try {
    const pending = yield select(selectors.getPendingPostRepeatDay)
    if (!pending) {
      yield put(actions.setPending('postRepeatDay', true))
      const orgId = yield select(getViewOrganizationSettingsId)
      yield call(makeAPIRequest, `${ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId)}/set-period`, {
        method: 'POST',
        data: {
          inactiveNotificationsPeriod: day,
        },
      })
      yield put(actions.orgInactiveNotifications.postRepeatDay.success(day))
    }
  } catch (error) {
    showError()
    yield put(actions.orgInactiveNotifications.postRepeatDay.fail(error))
  }
}
